export default "__VITE_ASSET__C9tH$p36__"